import { render } from "./index.vue?vue&type=template&id=0c5dbf00"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=0c5dbf00&lang=scss"
const cssModules = {}
import style1 from "./index.vue?vue&type=style&index=1&id=0c5dbf00&lang=scss&module=true"
cssModules["$style"] = style1

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__